import * as React from 'react';
import { clsx as cx } from 'clsx';

import * as styles from './LinkToFullVersion.css';

interface ILinkToFullVersionProps {
  isRedesign?: boolean;
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const LinkToFullVersion: React.FC<ILinkToFullVersionProps> = ({ isRedesign, onClick }) => {
  return (
    <a
      href="/"
      className={cx(styles['full-link'], isRedesign && styles['full-link--redesign'])}
      data-testid="LinkToFullVersion"
      onClick={onClick}
    >
      Полная версия сайта
    </a>
  );
};
